module.exports = __webpack_public_path__ + "static/img/node.5bed4a0a.png";